/**
 * CSS `text-transform: uppercase` yerine kullanılır — Türkçe i/İ, ı/I
 * karakterlerini doğru şekilde büyütür (native `toLocaleUpperCase`, tarayıcı
 * desteği evrensel). CSS text-transform tarayıcının locale-aware olmayan
 * varsayılan case-folding kuralını çalıştırır: küçük harf `i` (noktalı) →
 * `I` (noktasız) olur, oysa Türkçede karşılığı `İ` (noktalı büyük I,
 * U+0130) olmalıdır ("Giriş" → "GIRIS" değil "GİRİŞ" olmalı).
 *
 * lang !== 'tr' ise sıradan (locale-agnostic) İngilizce büyütme kullanılır.
 *
 * @param {string} str
 * @param {'tr'|'en'|string} lang
 * @returns {string}
 */
export function localeUpperCase(str, lang) {
  if (!str) return str;
  return String(str).toLocaleUpperCase(lang === 'tr' ? 'tr-TR' : 'en-US');
}
